<template>
  <app-page-wrapper-grid v-scroll-target class="shopping-cart">
    <div class="iw-layout-grid__row p-l-16 p-r-16 p-t-25">
      <div class="iw-layout-grid__col--span-12">
        <back-button v-if="showSeatLink" :route-to="{ name: ROUTE_NAMES.VENUE_CONTAINER }" class="shopping-cart__back" />
        <back-button
          v-else-if="activeVendor"
          app-link
          :route-to="{ name: ROUTE_NAMES.MENU, params: { vendor: this.activeVendor.id } }"
          class="shopping-cart__back"
        />
        <back-button v-else app-link :route-to="{ name: ROUTE_NAMES.VENDOR_PICKER }" class="shopping-cart__back" />
      </div>
      <div class="iw-layout-grid__col--span-7 shopping-cart__collection">
        <div class="shopping-cart__header"></div>

        <h1 class="shopping-cart__title">Your Order</h1>
        <delivery-options class="m-t-20"></delivery-options>
        <shopping-cart-item
          v-for="(product, index) in cartItems"
          :key="index"
          :index="index"
          :product="product"
          :read-only="false"
        />
      </div>
      <div class="iw-layout-grid__col--span-1"></div>
      <div class="iw-layout-grid__col--span-4">
        <shopping-cart-total :cart-items="availableCartItems" />
      </div>
    </div>
  </app-page-wrapper-grid>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ShoppingCartItem from "./components/cart-item/ShoppingCartItem";
import ShoppingCartTotal from "./components/cart-total/ShoppingCartTotal";
import DeliveryOptions from "./components/cart-delivery-options/DeliveryOptions";
import BackButton from "../../components/buttons/back-button/BackButton.vue";
import { ERROR_PICK_UP_TIME_SELECTED_NOT_AVAILABLE } from "@/../app-constants";
import { showDialog, ROUTE_NAMES } from "@/utils";

export default {
  name: "ShoppingCart",
  components: {
    ShoppingCartTotal,
    ShoppingCartItem,
    DeliveryOptions,
    BackButton
  },
  data: function() {
    return {
      ROUTE_NAMES,
      orderAheadActiveVendorId: ""
    };
  },
  computed: {
    ...mapGetters({
      activeVenueUrl: "venue/getActiveVenueUrl",
      venueInfo: "venue/getVenueInfo",
      activeVendor: "vendor/getActiveVendor",
      vendorsList: "vendor/getVendorsList",
      cartItems: "cart/getCartItems",
      cartItemsSize: "cart/getCartSize",
      availableCartItems: "cart/getAvailableCartItems",
      seatRequired: "venueSettings/seatRequired"
    }),
    showSeatLink() {
      return this.seatRequired && !this.vendorsList.length;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.params.orderAheadActiveVendorId) {
        vm.orderAheadActiveVendorId = to.params.orderAheadActiveVendorId;
      }
      vm.prevRoute = from;
    });
  },
  mounted() {
    this.updatePickup();
  },
  methods: {
    ...mapActions({
      resetOrderAheadState: "orderAhead/resetState"
    }),
    updatePickup() {
      if (!this.activeVendor?.pickupTimeSelectionEnabled && this.orderAheadActiveVendorId) {
        showDialog(this, "", ERROR_PICK_UP_TIME_SELECTED_NOT_AVAILABLE);
        this.resetOrderAheadState();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.shopping-cart {
  font-size: 14px;
  min-height: calc(100vh - 80px);

  &__header {
    @include respond-to-mobile {
      background-color: $border-color;
      position: absolute;
      width: 100%;
      left: 0;
    }
  }

  &__collection {
    > h2 {
      padding-bottom: 12px;
    }
  }

  &__title {
    font-size: 20px;
  }

  hr {
    border: none;
    opacity: 0.3;
    height: 1px;
    background-color: var(--group-3-color-3);
  }
}
</style>
